import Defaults from '~/scripts/constants/defaults';
import FileUpload from '~/scripts/services/model/file-upload';
import APIV5 from '~/models/api';
import templateModalUploadClassic from '../modal/modal-uploading.html';
import ModalUploadingController from '../modal/modal-uploading.controller';

/* globals Knitiv */

export default class UploadClassicController {
	/** @type {any} */
	#labels;

	/* @ngInject */
	/**
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} MailService
	 * @param {import('~/scripts/providers/models/notification').NotificationService} Notification
	 */
	constructor(
		$filter,
		$injector,
		$q,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		MailService,
		Notification,
	) {
		this.$filter = $filter;
		this.$injector = $injector;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.MailService = MailService;
		this.Notification = Notification;

		this.#labels = {};

		/** @type {any[]} */
		this.errors = [];

		/** @type {import('angular').IFormController | undefined} */
		this.form = undefined;

		this.fileParams = {
			camera: true,
			local: true,
			tree: true,
			html: true,
			accept: ['*'],
		};

		/** @type {FileUpload[]} */
		this.files = [];

		this.mailOptions = {
			open: false,
			hideSubject: false,
		};
		this.mail = {
			list: [
				{
					type: 'from',
					kid: $rootScope.context?.profil?.kid || null,
					name: $rootScope.context?.profil?.name || null,
					email: $rootScope.context?.profil?.email || null,
				},
				{
					type: 'cc',
					kid: $rootScope.context?.profil?.kid || null,
					name: $rootScope.context?.profil?.name || null,
					email: $rootScope.context?.profil?.email || null,
				},
			],
			body: null,
			body_alt: null,
			code_type: 'KEMAIL_PUBLISH',
			subject: null,
		};

		/** @type {string} */
		this.navClass = '';

		/** @type {?Function} */
		this.onCancel = null;

		/** @type {?Function} */
		this.onFinish = null;

		/** @type {?Function} */
		this.onSubmit = null;

		/** @type {any} */
		this.options = {};
	}

	$onInit() {
		this.#labels = {
			date: this.$translate.instant('import.file-date'),
			isa: this.$translate.instant('object.typedoc'),
			name: this.$translate.instant('import.file-name'),
			suffix: this.$translate.instant('import.file-name-suffix'),
			wf: this.$translate.instant('object.workflow'),
			wfallocator: this.$translate.instant('object.workflow-allocator'),
			wfcomment: this.$translate.instant('object.workflow-comment'),
			wfstate: this.$translate.instant('workflow.initial-state'),
		};

		this.$scope.$watch(
			() => this.files.map(f => ({
				ctxs:  f.ctxs,
				date:  f.date,
				isa:   f.isa,
				links: f.links,
				name:  f.name,
			})),
			() => this.$timeout(() => this.setErrors()),
			true,
		);

		return this.getAuthorizedMimetypes();
	}

	/**
	 * Adds files
	 *
	 * @param {File[]|FileList[]} files
	 */
	addFiles(files) {
		if (this.options.maxFiles && files.length > this.options.maxFiles) {
			this.Notification.warning({
				title: this.$translate.instant('error.file-not-imported-title'),
				message: this.$filter('sprintf')(this.$translate.instant('error.file-max-number'), this.options.maxFiles),
			});
			files.splice(this.options.maxFiles);
		}

		for (const file of files) {
			if (file instanceof FileList) {
				Array.prototype.forEach.call(file, item => {
					const fileUpload = new FileUpload(this.$injector, item);
					if (this.options.isa) {
						fileUpload.isa = this.options.isa;
					}
					this.files.push(fileUpload);
					this.$timeout(() => {
						this.$scope.$apply();
					});
				});
			}
			else {
				const fileUpload = new FileUpload(this.$injector, file);
				if (this.options.isa) {
					fileUpload.isa = this.options.isa;
				}
				this.files.push(fileUpload);
				this.$timeout(() => {
					this.$scope.$apply();
				});
			}
		}
	}

	cancel() {
		if (typeof this.onCancel === 'function') {
			this.onCancel();
		}
	}

	disableSync() {
		this.files.map(file => {
			file.sync = false;
			return file;
		});
	}

	async getAuthorizedMimetypes() {
		const result = await APIV5.instance.getMimetype({ id: 'upload-classic.get-authorized-mimetypes' });
		this.fileParams.accept = result.list;
	}

	setErrors() {
		this.errors.length = 0;
		if (this.form?.$error) {
			for (const [key, errors] of Object.entries(this.form.$error)) {
				for (const error of errors) {
					const [node, linkerKid, index] = error.$name?.split('|') ?? [];
					if (index !== undefined) {
						const file = this.files[Number.parseInt(index, 10)];
						const context = file.ctxs.find(c => c.node === node && c.linker_kid === linkerKid);
						const label = context?.component.label ?? this.#labels[node];

						if (label) {
							/** @type {any} */
							let errorsFile = this.errors.find(errorByFile => errorByFile.index === Number.parseInt(index, 10) + 1);
							if (errorsFile === undefined) {
								errorsFile = {
									index:  Number.parseInt(index, 10) + 1,
									file:   file.name,
									errors: [],
								}
								this.errors.push(errorsFile);
							}
							errorsFile.errors.push({
								label,
								error: `error.upload.${key}`,
							});
						}
					}
				}
			}
		}
	}

	hasSync() {
		return this.files.some(f => f.sync);
	}

	/**
	 * @param {FileUpload} file
	 * @param {number} index
	 */
	updateDate(file, index) {
		if (index === 0) {
			for (const [k, file2] of this.files.entries()) {
				if (file2.sync && k !== 0) {
					file2.date = file.date;
				}
			}
		}
		else if (file.date !== this.files[0].date) {
			this.files[index].sync = false;
		}
	}

	upload() {
		let verif = true;
		for (const file of this.files) {
			if (verif) {
				if ((!file.name || file.name.trim() === '') && (!file.suffix || file.suffix.trim() === '')) {
					this.Notification.error({
						title: this.$translate.instant('error.unable-to-import'),
						message: `${file.file?.name} - ${this.$translate.instant('error.missing-name')}`,
					});
					verif = false;
				}
				else if (!file.isa) {
					this.Notification.error({
						title: this.$translate.instant('error.unable-to-import'),
						message: `${file.file.name} - ${this.$translate.instant('error.missing-typedoc')}`,
					});
					verif = false;
				}
				else if (file.minLinks > 0 && file.links.length < file.minLinks) {
					this.Notification.error({
						title: this.$translate.instant('error.unable-to-import'),
						message: `${file.file.name} - ${this.$translate.instant('error.missing-contexts')}`,
					});
					verif = false;
				}
				else if (!file.date) {
					this.Notification.error({
						title: this.$translate.instant('error.unable-to-import'),
						message: `${file.file.name} - ${this.$translate.instant('error.missing-date')}`,
					});
					verif = false;
				}

				if (verif) {
					// Contrôle des contextes après sélection
					/** @type {any} */
					const contextTemporary = {};

					for (const context of file.ctxs) {
						const name = context.placeholder + (context.linker_kid === '0' ? '' : ` :: ${context.linker_info.name}`);
						if (context.card.to && typeof context.card.to === 'object') {
							for (const [k, from] of Object.entries(context.card.from)) {
								contextTemporary[k] = {
									min: from,
									max: Defaults.KCARDN,
									qte: null,
									name,
								};
							}
							for (const [k, to] of Object.entries(context.card.to)) {
								contextTemporary[k].max = to;
							}
						}
						else if (typeof context.card.to === 'number') {
							contextTemporary[`${context.node}|${context.linker_kid}`] = {
								min: context.card.from,
								max: context.card.to,
								qte: 0,
								name,
							};
						}
					}

					for (const link of file.links) {
						if (`${link.class_kid}|${link.linker_kid}` in contextTemporary) {
							contextTemporary[`${link.class_kid}|${link.linker_kid}`].qte++;
						}
					}

					for (const context of Object.values(contextTemporary)) {
						if (context.qte > context.max) {
							this.Notification.warning({
								title: this.$translate.instant('error.unable-to-process'),
								message: `${file.file.name} - ${this.$translate.instant('error.too-many-items-type', {
									name: context.placeholder,
								})}`,
							});
							verif = false;
						}
						else if (context.qte < context.min) {
							this.Notification.warning({
								title: this.$translate.instant('error.unable-to-process'),
								message: `${file.file.name} - ${this.$translate.instant('error.not-enough-items-type', {
									name: context.name,
								})}`,
							});
							verif = false;
						}
					}
				}
			}
		}

		if (verif) {
			if (typeof this.onSubmit === 'function') {
				this.onSubmit();
			}

			const modalInstance = this.$uibModal.open({
				ariaLabelledBy: 'modal-uploading-title',
				ariaDescribedBy: 'modal-uploading-body',
				backdrop: false,
				controller: ModalUploadingController,
				controllerAs: '$ctrl',
				template: templateModalUploadClassic,
				size: 'sm',
				resolve: {
					files: () => this.files,
				},
				windowClass: 'modal-upload',
			});

			modalInstance.opened
				// eslint-disable-next-line unicorn/no-reduce,promise/no-nesting,unicorn/no-array-reduce
				.then(() => this.files.reduce(
					// @ts-expect-error
					(p, file) => p
						.then(
							() => file.upload(),
						)
						.then(() => file.prepareFinish())
						.catch(error => {
							console.error('error', error);
						}),
					this.$q.when(true),
				))
				.then(result => {
					if (result) {
						this.Notification.success({
							title: this.$translate.instant('import.imported-files-title'),
							message: this.$translate.instant('import.imported-files-message'),
						});

						this.$timeout(() => {
							modalInstance.close();
						}, 1000);

						if (typeof this.onFinish === 'function') {
							this.onFinish();
						}
						return this.files;
					}
					return false;
				})
				.then(files => {
					if (this.mailOptions.open && files) {
						for (const file of files) {
							if (file.uploaded) {
								// noinspection JSCheckFunctionSignatures
								this.mail.list.push(
									// @ts-ignore
									{
										type: 'link_knode',
										kid: file.kid,
									},
								);
							}
						}
						this.sending = true;
						return this.MailService.send(this.mail);
					}
					return files;
				})
				.catch(error => {
					let message = this.$translate.instant('error.file-not-imported-error');

					if ('status' in error && error.status === -1) {
						message = this.$translate.instant('error.network-disconnected');
					}
					console.error(error);

					this.Notification.warning({
						title: this.$translate.instant('error.file-not-imported-title'),
						template: message,
					});
				});
		}
	}
}
